import React from 'react';
import logo from '../../../../assets/providers/itrent.png';
import { ProviderMeta } from '../types';

const PROVIDER_KEY = 'itrent';

const HelpBlock = () => {
  return (
    <div>
      <p>To connect to iTrent please contact us.</p>

      <p>
        For further help on this, please see our{' '}
        <a href="https://go.scrtracker.com/3QP1hbt" target="blank">
          help guides.
        </a>
      </p>
    </div>
  );
};

export const ITRENT_JSON_MODE_FEATURE = 'providers.itrent.json';

const soapMode = { id: 'SOAP', value: 'SOAP' };
const jsonMode = { id: 'JSON', value: 'JSON' };

export const itrentIntegrationModeValues = (
  jsonModeEnabled: boolean,
  storedMode?: unknown
) =>
  jsonModeEnabled || storedMode === 'JSON' ? [soapMode, jsonMode] : [soapMode];

export const itrentConnectionFields = (
  jsonModeEnabled: boolean,
  storedMode?: unknown
) => [
  {
    key: 'integrationMode',
    label: 'Integration mode',
    type: 'singleselect',
    showEmpty: false,
    values: itrentIntegrationModeValues(jsonModeEnabled, storedMode),
    readValue: (value: unknown) => (value === 'JSON' ? 'JSON' : 'SOAP'),
  },
  {
    key: 'username',
    label: 'Username',
    type: 'textbox',
  },
  {
    key: 'password',
    label: 'Password',
    type: 'password',
  },
  {
    key: 'partyName',
    label: 'Party Name',
    type: 'textbox',
  },
  {
    key: 'udfCategories',
    label: 'UDF Categories',
    type: 'valueslist',
  },
  {
    key: 'url',
    label: 'URL',
    type: 'textbox',
  },
];

export const applyItrentJsonMode = <T extends { key: string }>(
  providers: T[],
  jsonModeEnabled: boolean,
  storedMode?: unknown
): T[] =>
  providers.map((provider) =>
    provider.key === PROVIDER_KEY
      ? {
          ...provider,
          connectionFields: itrentConnectionFields(jsonModeEnabled, storedMode),
        }
      : provider
  );

export default {
  key: PROVIDER_KEY,
  name: 'iTrent',
  logo: logo,
  url: 'https://go.scrtracker.com/3R62dIN',
  connectionFields: itrentConnectionFields(false),
  HelpBlock,
} as ProviderMeta;
